import { motion, useInView } from 'framer-motion';
import { useRef } from 'react';
import Plane from './Plane';
import Note from './Note';

type ExperienceProps = {
  loadingComplete: boolean;
}

export default function Experience({loadingComplete}: ExperienceProps) {
  const experienceRef = useRef(null);
  const expIsInView = useInView(experienceRef, { once: true });

  return(
    <section id='experience' className='uppercase w-full relative'>
      <div className='container text relative border-top-accent'>
        <motion.h2
          transition={{ duration: 1, ease: [0.075, 0.82, 0.165, 1], delay: .2}}
          initial={{x: -100, opacity: 0}}
          animate={loadingComplete && expIsInView ? {x: 0, opacity: 1} : {}}
        >Professional experience</motion.h2>
        <motion.h1
          transition={{ duration: 2, ease: [0.075, 0.82, 0.165, 1], delay: .3}}
          initial={{y: 10, opacity: 0}}
          animate={loadingComplete && expIsInView ? {y: 0, opacity: 1} : {}}
        >Twitch 2024&ndash;Now</motion.h1>
        <motion.h1
          transition={{ duration: 2, ease: [0.075, 0.82, 0.165, 1], delay: .3}}
          initial={{y: 10, opacity: 0}}
          animate={loadingComplete && expIsInView ? {y: 0, opacity: 1} : {}}
          className='text-[4vw]'
        >VMWare 2020&ndash;2024</motion.h1>
        <motion.h1
          ref={experienceRef}
          transition={{ duration: 2, ease: [0.075, 0.82, 0.165, 1], delay: .4}}
          initial={{y: 10, opacity: 0}}
          animate={loadingComplete && expIsInView ? {y: 0, opacity: 1} : {}}
          className='text-[3vw]'
        >Pivotal 2018&ndash;2020</motion.h1>
        <Note
          text={"At Twitch, I rebuilt TwitchCon’s website from the ground up, overseeing everything from conceiving the vision and collaborating with designers to coding the site. Day 0 traffic exceeded 200,000 devices, a 68% increase over the previous two years. I specialize in creating web experiences that boost user engagement and bolster brand awareness while ensuring the tech stack aligns with business needs."}
          typingAnimation={false}
          delayOffset={.5}
          loadingComplete={loadingComplete}
        />
      </div>
      <Plane></Plane>
    </section>
  );
}